module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "galley-rw"
  }, [_c('section', {
    staticClass: "body-rw Chapter-rw page-open-right-rw",
    attrs: {
      "epub:type": "bodymatter chapter",
      "id": "Chapter1"
    }
  }, [_c('div', {
    staticClass: "title-block-rw",
    attrs: {
      "id": "title-block7"
    }
  }, [_c('p', {
    staticClass: "title-num-rw",
    attrs: {
      "id": "title-num1"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/TOC",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter One")])])]), _vm._v(" "), _c('p', {
    staticClass: "dateline-rw",
    attrs: {
      "id": "dateline1"
    }
  }, [_vm._v("One year ago.")]), _vm._v(" "), _c('p', {
    staticClass: "firstpara-rw",
    attrs: {
      "id": "p18"
    }
  }, [_c('span', {
    staticClass: "raisedcap-rw"
  }, [_vm._v("Y")]), _vm._v("ou got laid last night, didn’t you?” Simon Tennant asked as he recognized the look on his friend’s face. He’d seen it many times before. A cross between “holy hell, I’m lucky” and “what the fuck did I just do?” “I don’t know how you do it, man.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p19"
    }
  }, [_vm._v("Matt Stanning grinned as he fastened his seat belt. “Gotta love weddings,” he said. “They make chicks crazy.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p20"
    }
  }, [_vm._v("“But mine? You couldn’t keep it in your pants until I was safely on my honeymoon? You better not have hit and quit one of Sadie’s friends, or I’ll never hear the end of it!” He was lying. His fiancée had a soft spot for Matt. In truth, Sadie had a soft spot for a lot of people; it was one of the things he loved about her.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p21"
    }
  }, [_vm._v("Simon took a deep breath, barely believing "), _c('i', [_vm._v("still")]), _vm._v(" that she was about to become his wife. A sense of peace was blooming in his body, almost as if he were dying and being drawn to the light. No wait—way wrong analogy. He came up empty for anything better. He checked his watch. In four hours, Sadie Walker would become Mrs. Simon Tennant, and his life would finally be complete.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p22"
    }
  }, [_vm._v("She was his anchor in the crazy world he worked in. The calm in the storm that raged through his professional life. After every mission, his only focus was getting home to her. Home. Sadie. He needed her in his life like a fire needs oxygen. He’d always thought that having a significant other would dull his desire to take the fight to the enemy, but that never happened. If anything, knowing he had her to come home to made him a better operative. Simply, his life was exponentially better with her in it. And he was about to make that permanent.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p23"
    }
  }, [_vm._v("“So who was it?” He flashed a look at Matt, whose smile faltered just a little.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p24"
    }
  }, [_vm._v("“You know, I’m not even sure she gave me her right name. Harry? Henrietta? Something like that.” Matt was frowning now.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p25"
    }
  }, [_vm._v("“She’s Sadie’s maid of honor. Her friends call her Harry,” Simon said as he shifted down to turn on the road to Sadie’s parents’ house. He was a little intimidated to be in the home of the director of the CIA. As if getting married wasn’t nerve-racking enough.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p26"
    }
  }, [_vm._v("“Funny, she told me I should call her Henrietta.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p27"
    }
  }, [_vm._v("Matt looked so perturbed Simon couldn’t help but laugh. He was about to explain a little about her history, when he noticed the security barriers in the middle of Sadie’s driveway were up, rendering it impassable.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p28"
    }
  }, [_vm._v("“What’s going on?” Matt asked as Simon pulled on the hand brake and got out of his car.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p29"
    }
  }, [_vm._v("“No idea.” Behind him he could hear Matt getting out of the car too.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p30"
    }
  }, [_vm._v("“Excuse me,” he called to a patrolling security man in black.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p31"
    }
  }, [_vm._v("The man did a double take and looked around him as if seeking assistance. Then he placed his hand on his sidearm and approached the gate.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p32"
    }
  }, [_vm._v("“Something’s not right,” Simon said in a low voice to Matt.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p33"
    }
  }, [_vm._v("Matt stayed silent.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p34"
    }
  }, [_vm._v("“Can I help you?” the security man said in a careful voice.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p35"
    }
  }, [_vm._v("“Hi there. Can we come in?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p36"
    }
  }, [_vm._v("“No one is allowed. Private. Come back later.” The security man was sweating.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p37"
    }
  }, [_vm._v("Simon could sense that Matt was about to explain that Simon was the groom, so he cut in. “Okay, no problem. We’ll come back this afternoon.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p38"
    }
  }, [_vm._v("They got back into the car and Simon threw it into reverse and slowly backed down the driveway. He rolled down his window and put the radio on loudly. As soon as he did that, the security man turned and walked away. There was nothing like music to divert attention and suspicion.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p39"
    }
  }, [_vm._v("“Ukrainian?” Matt asked.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p40"
    }
  }, [_vm._v("“I’d say southern Russian. He’s not a member of the director’s security team or the family’s. Something’s wrong.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p41"
    }
  }, [_vm._v("Simon’s Delta Force training immediately took over. He turned to Matt. “I’m going in.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p42"
    }
  }, [_vm._v("Matt didn’t hesitate. He shrugged out of his jacket and rolled up his sleeves. “How do you want to play this?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p43"
    }
  }, [_vm._v("“Not quite sure yet, but at least I’ve brought some toys to the party.” Simon flashed a wolfish grin.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p44"
    }
  }, [_vm._v("“Music to my ears.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p45"
    }
  }, [_vm._v("Simon parked the car far enough up the road that it was out of sight from the house. They jumped out as Simon popped the trunk with his fob and pulled aside the floor to reveal an array of small weapons.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p46"
    }
  }, [_vm._v("“Dude, you shouldn’t have,” Matt said as if he’d been presented with the best gift ever.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p47"
    }
  }, [_vm._v("Simon wanted to laugh, but in truth, he had only one thing on his mind and he was deadly serious about it: Get to Sadie. “Take extra ammo and the silencers. We have no idea how many of them there are.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p48"
    }
  }, [_vm._v("They took their weapons of choice. “Are you absolutely sure we’re not going to scale the wall and jump down in the middle of your mother-in-law-to-be’s garden party?” Matt said.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p49"
    }
  }, [_vm._v("It was possible. But his gut told him different. “You haven’t met Sadie’s mom. This would also be an entirely appropriate reaction to her.” He chambered a round and held Matt’s eyes. “You sure you’re okay with this?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p50"
    }
  }, [_vm._v("Matt looked away, unconcerned. “Hey, this is what we do. Let’s go get our girls.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p51"
    }
  }, [_vm._v("Simon nodded once and the two approached the wall around the property, smoothly scaled it, and started scoping out the grounds as they made their way to the house. Sadie was in there.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p52"
    }
  }, [_c('i', [_vm._v("His Sadie.")]), _c('i'), _vm._v("If anything happened to her…")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p53"
    }
  }, [_vm._v("Simon slid around the side of the wedding tent in the backyard. As he rounded the front, he found two men, guns holstered and smoking. He showed himself, just on the slim chance that they were the director’s guards. They went for their guns immediately, and he shot both of them in the forehead, barely registering the hits. He swung around instinctively to cover his back, but no one was there. He dragged the two men into the tent and closed the front flaps.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p54"
    }
  }, [_vm._v("“Delta Lima, check in,” a voice said over the walkie-talkie fastened to one of the men’s belts. Answer or not answer?")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p55"
    }
  }, [_vm._v("Simon took a breath. “Da.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p56"
    }
  }, [_vm._v("There was a long pause, and then the person at the other end clicked his "), _c('span', {
    staticClass: "smallcaps-rw",
    staticStyle: {
      "font-size": "82%"
    }
  }, [_vm._v("SPEAK")]), _vm._v(" button in acknowledgment.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p57"
    }
  }, [_vm._v("The tent flap moved, and he nearly took a shot. It was Matt. He needed to get a fucking grip on his emotions is what he needed to do right now.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p58"
    }
  }, [_vm._v("“There are two on the right side of the house. One has a tablet or something that he seems to be monitoring. He’s our mark, the one we need to question,” Matt said, casting his eyes over the dead men on the ground.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p59"
    }
  }, [_vm._v("“Copy that. It’ll be my pleasure,” Simon replied. The faster they got this done, the faster he could get to her. "), _c('i', [_vm._v("Damn it—why didn’t we elope?")])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p60"
    }
  }, [_vm._v("He exited the tent first. The lawn area was still empty. He ran for the house, so they could take the two men without the exposure of a direct approach. The guards were so focused on their tablet that Simon felt they could have just ambled up and asked them the time. Still, where was the fun in that?")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p61"
    }
  }, [_vm._v("He rounded the corner. “Hi there,” he said.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p62"
    }
  }, [_vm._v("About eight minutes later, they were inside the house, Simon taking the final kill-shot to end the immediate danger. “Where’s Sadie?” he asked her brother, James. James pointed to the corridor behind him and Simon didn’t hesitate. He needed eyes on her. As he approached her bedroom, she emerged, fear etched on her face.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p63"
    }
  }, [_vm._v("“Oh my God, Simon. Thank God. I didn’t know…” She dissolved into sobs that she stifled against his neck. His arms went around her. He was never letting her go. Never letting her out of his sight.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p64"
    }
  }, [_vm._v("“Simon, we need you,” James said. “My father is still in his study with two of the gunmen.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p65"
    }
  }, [_vm._v("He looked up; Matt, James, and James’s fiancée were all locked and loaded, waiting at the top of the stairs for him. “I have to go.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p66"
    }
  }, [_vm._v("“No—don’t leave me. Please don’t leave—” she begged, and his heart just about cracked open. But Simon had no choice. It was his duty.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p67"
    }
  }, [_vm._v("“I’ll be right back. I promise.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p68"
    }
  }, [_vm._v("She pulled away from him, makeup running down her face. “I can’t, Simon. This…” she gestured at the dead man. “I can’t…”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p69"
    }
  }, [_vm._v("“Look at me. I’ll be right back.” He kissed her on the forehead and stalked down the corridor toward the others. He looked back as they took the stairs. She was hugging her younger sister, eyes squeezed shut, sobbing. A part of his heart fell away into darkness. Who would leave anyone suffering like that, let alone the woman he loved? But he had a duty. A duty to protect the United States from enemies, foreign and domestic. And country came first. Always.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p70"
    }
  }, [_c('i', [_vm._v("Didn’t it?")])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p71"
    }
  }, [_vm._v("Ten minutes later, all the bad guys had been disposed of, but Sadie’s brother had been shot. Simon ran from the scene to Sadie, but she was already outside staring at the dead bodies in the exact place they would have said their vows. One look in her eyes told him that they weren’t going to get married that day.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p72"
    }
  }, [_vm._v("“Sadie, please—just listen,” he said, preempting anything that was going to come out of her mouth.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p73"
    }
  }, [_vm._v("“I can’t. I’m sorry. I see now what you do every day that you’re not with me. This is what you do every time you leave me.” She pointed at the knocked-over flower arrangements and the bloodstained aisle carpet.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p74"
    }
  }, [_vm._v("“Please, I just need to explain—” An ambulance’s sirens interrupted his plea.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p75"
    }
  }, [_vm._v("Sadie’s eyes flashed with horror. “Who…?” She looked at the front door.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p76"
    }
  }, [_vm._v("Simon cursed himself. “I’m sorry; James was shot. I think he’ll be fine, though.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p77"
    }
  }, [_vm._v("“What?” She took a deep breath and then swallowed. “I have to go see him.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p78"
    }
  }, [_vm._v("“I know.” He could feel the distance between them already. He’d been worried about this the whole time they’d been dating. He never told her exactly what he did on a day-to-day basis. And now he’d never have to. It was here, in her family home, the dead bodies and blood that she would never be able to unsee.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p79"
    }
  }, [_vm._v("“We’ll talk. Later maybe,” she said softly.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p80"
    }
  }, [_vm._v("He reached in to kiss her good-bye, but she flinched away, shattering his heart into a million dark pieces. Suddenly he was alone, ice cold, with blood on his hands. Literally.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p81"
    }
  }, [_vm._v("In that second, he knew with absolute certainty. No matter how much they’d talk, it would end the same way.")]), _vm._v(" "), _c('div', {
    staticClass: "decoration-rw",
    attrs: {
      "id": "decoration1"
    }
  }, [_c('p', {
    staticClass: "center-rw",
    attrs: {
      "id": "p82"
    }
  }, [_vm._v("*  *  *")])]), _vm._v(" "), _c('p', {
    staticClass: "firstpara-rw",
    attrs: {
      "id": "p83"
    }
  }, [_vm._v("Sadie watched the nurses and doctors flit about the ICU with a detachment that she fought against. She needed to be here for her brother. Mentally and emotionally here.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p84"
    }
  }, [_vm._v("She knew that no matter what she and Simon said, whatever they would discuss, it was over. The blood, his ability to leave her when she begged him not to, the "), _c('i', [_vm._v("blood")]), _vm._v(". She’d known that he was in the black ops field of the army since the day she’d received her beautiful engagement ring, but now she’d seen him kill someone. Without giving his victim a second look. And then she’d gone outside and seen the blood all over the floorboards, carpet, and chairs where they’d expected to take their vows—she looked at her watch—two hours ago. There couldn’t really be a clearer sign that this was not meant to be.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p85"
    }
  }, [_vm._v("“Hey.” His voice made her jump.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p86"
    }
  }, [_vm._v("She looked up at him for a long time, not knowing what to say, where to start. Just seeing him there bought tears to her eyes. She had loved him so much. Maybe she still did, but his job was so dangerous, and so brutal, how long would it be before he was killed or something would happen that would change things for them forever? And even if it didn’t, he would always be leaving her. He already treated his job as his wife and Sadie as his mistress, and now she knew for sure what he’d always left her for: death and destruction.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p87"
    }
  }, [_vm._v("“Is he okay?” Simon asked as he sat next to her.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p88"
    }
  }, [_vm._v("She nodded, looking straight ahead at the nurses’ station, not daring to meet his eyes in case she just threw herself into his arms.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p89"
    }
  }, [_vm._v("“But we’re not, are we?” he said.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p90"
    }
  }, [_vm._v("Sadie couldn’t bring herself to nod or shake her head. Any movement would take the conversation somewhere she didn’t want it to go, couldn’t bear it to go.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p91"
    }
  }, [_vm._v("“What happened? Look at me, damn it,” he said, pain in his voice. “You can’t just cut and run on our wedding day.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p92"
    }
  }, [_vm._v("She took a deep breath, praying her voice wouldn’t break and her chin wouldn’t quiver, and turned toward him. “You cut and run all the time. When I had the flu, when we were just about to leave to go to Samantha and Jake’s wedding, when we were supposed to take that vacation to Santa Barbara…movie dates, dinner dates. Your cell phone would chime and I knew I’d be on my own again. And I didn’t mind too much. I knew you had an important job. But…” She swallowed, trying to keep her shit together. “Now I know what you do. Every time you leave me, it was to go kill someone, walk into danger…and I can’t compete with that—I don’t even want to.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p93"
    }
  }, [_vm._v("Simon was silent, his eyes searching hers.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p94"
    }
  }, [_vm._v("She blinked slowly and turned back around to face the nurses’ station again. The nurse who had rushed James into the operating room appeared but didn’t look at Sadie. When the nurse disappeared again, she turned back to Simon.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p95"
    }
  }, [_vm._v("He was gone.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p96"
    }
  }, [_vm._v("For a second she couldn’t breathe, and then oxygen stuttered through her lungs and heaved out once, as sobs came from her stomach, her soul. He never once hesitated to fight for his country, but he refused to fight for her. She shook, and wept, and couldn’t stop.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p97"
    }
  }, [_vm._v("Not for a long, long time.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-220123d2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/s004-Chapter-001.vue
// module id = 69
// module chunks = 0